import {autoImplement} from '@/util';

export interface ApiWarehouse {
  Niederlassung: number;
  Lagerhalle: number;
  Bezeichnung: string;
  /* Info: string;
  LfdChargenNr: number|null;
  Kapazitaet: any|null;
  Fremdlager: 'J'|'N';
  InklFDChargenNr: 'J'|'N';
  Prodlager: 'J'|'N'|null;
  ArtikelNrWaage: string|null; */
}
export interface WarehouseFilters {
  Niederlassung?: number;
  Lagerhalle?: number;
}

export default class Warehouse extends autoImplement<ApiWarehouse>() {
  static fromApi(apiWarehouse: ApiWarehouse): Warehouse {
    return new Warehouse(apiWarehouse);
  }
}
